module.exports = __webpack_public_path__ + "static/img/TVC_btn.ad01679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/TVC_btn.png
// module id = ljSm
// module chunks = 1